<template>
  <div v-if="isGameModuleActive && assignedTasks.length > 0">
    <div class="bg-white text-black text-sm shadow rounded-b-xl py-2 mx-4 px-4">
      <ul class="divide-y divide-gray-200 space-y-1">
        <li
          v-for="task in assignedTasks"
          :key="task.id"
          class="flex items-center justify-between px-2 py-1"
        >
          <span class="text-sm">{{ task.description || task.title }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moduleManager from '../modules/index.js'

export default {
  name: 'TaskList',
  computed: {
    ...mapGetters('settings', ['tourSettings']),

    // Check if game module is active
    isGameModuleActive() {
      return moduleManager.isModuleActive('game')
    },

    // Flatten tasks to array for rendering
    tasksList() {
      const state = moduleManager.getModuleData('game') || {}
      const tasks = state.tasks || {}
      return Object.values(tasks).filter(
        (t) => t && (t.status === 'assigned' || t.status === 'completed')
      )
    },

    // Only tasks with status 'assigned'
    assignedTasks() {
      return (this.tasksList || []).filter((task) => task?.status === 'assigned')
    }
  }
}
</script>


